import { atom } from "lib/global-context";
import { QuizAnswers, QuizSteps } from "types/quiz";

// Common
export const currentStepAtom = atom<number>(0);
export const ageAtom = atom<number | null>(null);
export const userIdAtom = atom<number | null>(null);

// Wealth
export const goalTimelineAtom = atom<number | null>(null);
export const goalDescriptionAtom = atom<string | null>(null);
export const goalAmountAtom = atom<number | null>(null);

// Retirement Planning
export const ageEndAtom = atom<number | null>(null);
export const monthlyExpenseAtom = atom<number | null>(null);
export const emergencyFundAtom = atom<number | null>(null);

// Family Protection & Education Planning
export const quizCurrentStepAtom = atom<number>(1);
export const quizStepsAtom = atom<QuizSteps | null>(null);
export const quizAnswersAtom = atom<QuizAnswers>({});
